__turbopack_context__.v({
  "crop": "shot-frame-module__KJj54a__crop",
  "cropped": "shot-frame-module__KJj54a__cropped",
  "fadeFootOnPhone": "shot-frame-module__KJj54a__fadeFootOnPhone",
  "tiltLeft": "shot-frame-module__KJj54a__tiltLeft",
  "tiltRight": "shot-frame-module__KJj54a__tiltRight",
});
